import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  withIcon: "dibwszt05y",
  noContent: "dibnwbp60d"
});
const wrapper = "dibw1m7adpb";

export { modifiers, wrapper };
import "./pill.style.linaria.module.css";
//# sourceMappingURL=pill.style.js.map
